export default "__VITE_ASSET__Dnc7y4qt__"